import request from '@/request/request'

/**
 * 获取公开招租列表
 * @param {} parameter 
 * @returns 
 */
export function listApplyProject (parameter) {
  return request({
    url: '/e-find-property/bidApply/listApplyProject',
    method: 'post',
    data: parameter
  })
}

/**
 * 获取已进入公开招租阶段的项目列表
 * @param {} parameter
 * @returns
 */
export function listPublicBidProject (parameter) {
  return request({
    url: '/e-find-property/bidApply/listPublicBidProject',
    method: 'post',
    data: parameter
  })
}

/**
 * 查询公告截图列表
 * @param {} parameter
 * @returns
 */
export function listNoticeScreenshot (parameter) {
  return request({
    url: '/e-find-property/bidApply/listNoticeScreenshot',
    method: 'post',
    data: parameter
  })
}

/**
 * 查看公告截图
 * @param {} parameter
 * @returns
 */
export function previewNoticeScreenshot (parameter) {
  return request({
    url: '/e-find-property/bidApply/previewNoticeScreenshot',
    method: 'get',
    params: parameter
  })
}

/**
 * 下载公告截图
 * @param {} parameter
 * @returns
 */
export function downloadNoticeScreenshot (parameter) {
  return request({
    url: '/e-find-property/bidApply/downloadNoticeScreenshot',
    method: 'get',
    params: parameter,
    responseType: 'blob'
  })
}

/**
 * 查询项目函件列表
 * @param {} parameter
 * @returns
 */
export function listProjectLetter (parameter) {
  return request({
    url: '/e-find-property/bidApply/listProjectLetter',
    method: 'post',
    data: parameter
  })
}

/**
 * 查看项目函件
 * @param {} parameter
 * @returns
 */
export function previewProjectLetter (parameter) {
  return request({
    url: '/e-find-property/bidApply/previewProjectLetter',
    method: 'get',
    params: parameter
  })
}

/**
 * 下载项目函件
 * @param {} parameter
 * @returns
 */
export function downloadProjectLetter (parameter) {
  return request({
    url: '/e-find-property/bidApply/downloadProjectLetter',
    method: 'get',
    params: parameter,
    responseType: 'blob'
  })
}

export function saveProjectLetterReceipt (parameter) {
  return request({
    url: '/e-find-property/bidApply/saveProjectLetterReceipt',
    method: 'post',
    data: parameter
  })
}

export function deleteProjectLetterReceipt (parameter) {
  return request({
    url: '/e-find-property/bidApply/deleteProjectLetterReceipt',
    method: 'post',
    data: parameter
  })
}

export function listIntentionPartyMaterial (parameter) {
  return request({
    url: '/e-find-property/bidApply/listIntentionPartyMaterial',
    method: 'post',
    data: parameter
  })
}

export function downloadIntentionPartyMaterial (parameter) {
  return request({
    url: '/e-find-property/bidApply/downloadIntentionPartyMaterial',
    method: 'get',
    params: parameter,
    responseType: 'blob'
  })
}

export function getBidProjectBiddingParam (parameter) {
  return request({
    url: '/e-find-property/bidApply/getBidProjectBiddingParam',
    method: 'post',
    data: parameter
  })
}

export function saveBidProjectBiddingParam (parameter) {
  return request({
    url: '/e-find-property/bidApply/saveBidProjectBiddingParam',
    method: 'post',
    data: parameter
  })
}

/**
 * 删除公开招租信息
 * @param {} parameter 
 * @returns 
 */
export function deleteApplyProject (parameter) {
  return request({
    url: '/e-find-property/bidApply/deleteApplyProject',
    method: 'delete',
    params: parameter
  })
}

/**
 * 获取意向发布列表
 * @param {} parameter 
 * @returns 
 */
export function listIntentProject (parameter) {
  return request({
    url: '/e-find-property/intentLease/listIntentProject',
    method: 'post',
    data: parameter
  })
}

export function listPublishedIntentProject (parameter) {
  return request({
    url: '/e-find-property/intentLease/listPublishedIntentProject',
    method: 'post',
    data: parameter
  })
}

export function listIntentProjectPartyInfo (parameter) {
  return request({
    url: '/e-find-property/intentLease/listIntentProjectPartyInfo',
    method: 'post',
    data: parameter
  })
}

export function saveIntentProjectPartyInfo (parameter) {
  return request({
    url: '/e-find-property/intentLease/saveIntentProjectPartyInfo',
    method: 'post',
    data: parameter
  })
}

/**
 * 删除意向发布信息
 * @param {} parameter 
 * @returns 
 */
export function deleteIntentProject (parameter) {
  return request({
    url: '/e-find-property/intentLease/deleteIntentProject',
    method: 'delete',
    params: parameter
  })
}

/**
 * 房源信息选择权证详情
 * @param {} parameter 
 * @returns 
 */
export function listWarrantByHouseWebId (parameter) {
  return request({
    url: '/e-find-property/housingResources/listWarrantByHouseWebId',
    method: 'post',
    data: parameter
  })
}

/**
 * 获取房源详情列表
 * @param {} parameter 
 * @returns 
 */
export function listSelectHouseDetailByBid (parameter) {
  return request({
    url: '/e-find-property/housingResources/listSelectHouseDetailByBid',
    method: 'post',
    data: parameter
  })
}

/**
 * 保存进场公开招租申请
 * @param {} parameter 
 * @returns 
 */
export function saveBidApply (parameter) {
  return request({
    url: '/e-find-property/bidApply/saveBidApply',
    method: 'post',
    data: parameter
  })
}

/**
 * 提交权证信息
 * @param {} parameter 
 * @returns 
 */
export function submitBidApply (parameter) {
  return request({
    url: '/e-find-property/bidApply/submitBidApply',
    method: 'post',
    data: parameter
  })
}

/**
 * 获取权证详情
 * @param {} parameter 
 * @returns 
 */
export function getApplyDetail (parameter) {
  return request({
    url: '/e-find-property/bidApply/getApplyDetail',
    method: 'get',
    params: parameter
  })
}

/**
 * 保存意向发布项目登记
 * @param {} parameter 
 * @returns 
 */
export function saveIntentLease (parameter) {
  return request({
    url: '/e-find-property/intentLease/saveIntentLease',
    method: 'post',
    data: parameter
  })
}

/**
 * 提交意向发布项目登记
 * @param {} parameter 
 * @returns 
 */
export function submitIntentLease (parameter) {
  return request({
    url: '/e-find-property/intentLease/submitIntentLease',
    method: 'post',
    data: parameter
  })
}

/**
 * 获取意向发布详情
 * @param {} parameter 
 * @returns 
 */
export function getIntentDetail (parameter) {
  return request({
    url: '/e-find-property/intentLease/getIntentDetail',
    method: 'get',
    params: parameter
  })
}

/**
 * 获取房源详情列表
 * @param {} parameter 
 * @returns 
 */
export function listSelectHouseDetailByIntent (parameter) {
  return request({
    url: '/e-find-property/housingResources/listSelectHouseDetailByIntent',
    method: 'post',
    data: parameter
  })
}
